import Vue from 'vue'
import Http from 'vue-resource'

Vue.use(Http)

Vue.http.options.root = process.env.API_LINK;

Vue.http.interceptors.push((request, next) => {
	request.headers.set("Accept", "application/json")
	request.headers.set("X-Access-Token", Vue.storage.get('X-Access-Token'))
	request.headers.set("X-Access-Worker", Vue.storage.get('worker'))


	//TODO refactor it
	if(request.url !== 'worker/list')
		request.headers.set("X-Local-City", Vue.storage.get('X-Local-City'))

	next()
})



// WEBPACK FOOTER //
// ./src/common/httpConfig.js